import { Component, EventEmitter, Input, Output } from "@angular/core";

import { ActionButtonComponent } from "../../buttons/action-button/action-button.component";
import { ActionButtonSize, ActionButtonType, } from "../../buttons/action-button/action-button.model";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-form-container",
  templateUrl: "./form-container.component.html",
  styleUrls: ["./form-container.component.scss"],
  imports: [ActionButtonComponent, TranslateModule],
  standalone: true,
})
export class FormContainerComponent {
  ActionButtonSize = ActionButtonSize;
  ActionButtonType = ActionButtonType;

  @Input() title: string = "";
  @Input() confirmDisabled: boolean = false;
  @Input() cancelText: string = "webPos.Cancel";
  @Input() confirmText: string = "webPos.Confirm";
  @Input() additionalActionText: string | null = null;
  @Input() additionalActionDisabled: boolean = false;
  @Input() showCancelButton: boolean = true;
  @Input() showConfirmButton: boolean = true;
  @Output() onSubmit = new EventEmitter<void>();
  @Output() onCancel = new EventEmitter<void>();
  @Output() onAdditionalAction = new EventEmitter<void>();

  cancel() {
    this.onCancel.emit();
  }

  submit() {
    this.onSubmit.emit();
  }

  additionalAction() {
    this.onAdditionalAction.emit();
  }
}
